import clsx from 'clsx';
import type { GoResult } from '../hooks/useGoQuery';

const TYPE_LABELS: Record<GoResult['type'], string> = {
  document: 'Document',
  page: 'Page',
  project: 'Project',
  organisation: 'Organisation',
  'reconstructed-document': 'Recon',
};

const TYPE_BADGE_CLASSES: Record<GoResult['type'], string> = {
  document: 'bg-blue-50 text-blue-700 ring-blue-600/20 dark:bg-blue-500/10 dark:text-blue-400 dark:ring-blue-500/20',
  page: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-500/10 dark:text-emerald-400 dark:ring-emerald-500/20',
  project:
    'bg-purple-50 text-purple-700 ring-purple-600/20 dark:bg-purple-500/10 dark:text-purple-400 dark:ring-purple-500/20',
  organisation:
    'bg-amber-50 text-amber-700 ring-amber-600/20 dark:bg-amber-500/10 dark:text-amber-400 dark:ring-amber-500/20',
  'reconstructed-document':
    'bg-cyan-50 text-cyan-700 ring-cyan-600/20 dark:bg-cyan-500/10 dark:text-cyan-400 dark:ring-cyan-500/20',
};

export function GoResultsList({
  results,
  selectedIndex,
  onHover,
  onPick,
}: {
  results: GoResult[];
  selectedIndex: number;
  onHover: (index: number) => void;
  onPick: (result: GoResult, openInNewTab: boolean) => void;
}) {
  return (
    <ul className="max-h-80 overflow-y-auto py-1">
      {results.map((result, index) => (
        <li key={`${result.type}-${result.id}`}>
          <button
            type="button"
            onMouseEnter={() => onHover(index)}
            onClick={(e) => onPick(result, e.metaKey || e.ctrlKey)}
            className={clsx(
              'flex w-full items-center gap-3 px-4 py-2 text-left text-sm',
              index === selectedIndex && 'bg-zinc-100 dark:bg-zinc-800',
            )}
          >
            <span
              className={clsx(
                'inline-flex w-24 shrink-0 justify-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
                TYPE_BADGE_CLASSES[result.type],
              )}
            >
              {TYPE_LABELS[result.type]}
            </span>
            <span className="shrink-0 font-mono text-xs text-zinc-500 dark:text-zinc-400">{result.id.slice(0, 8)}</span>
            <span className="min-w-0 truncate text-zinc-900 dark:text-white">{result.label}</span>
            {result.context && (
              <span className="min-w-0 truncate text-xs text-zinc-500 dark:text-zinc-400">{result.context}</span>
            )}
          </button>
        </li>
      ))}
    </ul>
  );
}
